export const currentDirectory = '/';
export const useCaseSensitiveFileNames = true;
